import * as React from 'react';
import { TextField } from '@material-ui/core';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';

// The stock @rjsf/material-ui TextareaWidget only reads `ui:options.rows` and
// always passes it to MUI v4's TextField as a *fixed* row count (defaulting
// to 5 if unset). MUI v4 only auto-grows a multiline TextField when `rowsMax`
// is also supplied, and the stock widget never forwards that option — so
// long answers just scroll inside the fixed box instead of the field
// growing. This field renders the TextField directly so `rowsMax` can
// actually be applied, giving real auto-grow behavior.
export const CustomAutoGrowTextareaField = ({
  onChange,
  required,
  formData,
  schema,
  uiSchema,
  rawErrors,
}: FieldExtensionComponentProps<string>) => {
  const { title, description } = schema;
  const options = uiSchema?.['ui:options'] ?? {};
  const rows = typeof options.rows === 'number' ? options.rows : 3;
  const maxRows = typeof options.maxRows === 'number' ? options.maxRows : undefined;

  const hasError = !!rawErrors && rawErrors.length > 0;

  return (
    <TextField
      fullWidth
      multiline
      rows={rows}
      rowsMax={maxRows}
      label={title}
      value={formData || ''}
      onChange={event => onChange(event.target.value)}
      error={hasError}
      helperText={hasError ? rawErrors!.join(', ') : description}
      required={required}
    />
  );
};
